var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{staticClass:"md-12"},[(_vm.isfaq)?_c('servicerequestdetails'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }